import {
  DATA_CONNECTOR_UPDATE_EXTERNALDATABASE_FOR_SALESFORCE_BEGIN,
  DATA_CONNECTOR_UPDATE_EXTERNALDATABASE_FOR_SALESFORCE_SUCCESS,
  DATA_CONNECTOR_UPDATE_EXTERNALDATABASE_FOR_SALESFORCE_FAILURE,
  DATA_CONNECTOR_UPDATE_EXTERNALDATABASE_FOR_SALESFORCE_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
export function updateExternaldatabaseForSalesforce(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_UPDATE_EXTERNALDATABASE_FOR_SALESFORCE_BEGIN,
    });
    const { projectId, version, externalDbUuid, fields, collectionName } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.put(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/salesforce/${externalDbUuid}`,
        { fields: fields, collectionName: collectionName },
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_UPDATE_EXTERNALDATABASE_FOR_SALESFORCE_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_UPDATE_EXTERNALDATABASE_FOR_SALESFORCE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}
export function dismissUpdateExternaldatabaseForSalesforceError() {
  return {
    type: DATA_CONNECTOR_UPDATE_EXTERNALDATABASE_FOR_SALESFORCE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_UPDATE_EXTERNALDATABASE_FOR_SALESFORCE_BEGIN:
      return {
        ...state,
        updateExternaldatabaseForSalesforcePending: true,
        updateExternaldatabaseForSalesforceError: null,
      };

    case DATA_CONNECTOR_UPDATE_EXTERNALDATABASE_FOR_SALESFORCE_SUCCESS:
      return {
        ...state,
        updateExternaldatabaseForSalesforcePending: false,
        updateExternaldatabaseForSalesforceError: null,
      };

    case DATA_CONNECTOR_UPDATE_EXTERNALDATABASE_FOR_SALESFORCE_FAILURE:
      return {
        ...state,
        updateExternaldatabaseForSalesforcePending: false,
        updateExternaldatabaseForSalesforceError: action.data.error,
      };

    case DATA_CONNECTOR_UPDATE_EXTERNALDATABASE_FOR_SALESFORCE_DISMISS_ERROR:
      return {
        ...state,
        updateExternaldatabaseForSalesforceError: null,
      };

    default:
      return state;
  }
}
